/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Provides all data-containers.
 */
import List from './list';
import DropDownSearch from './dropDownSearch';
import FormBuilder from './formBuilder';
import DynamicTable from './dynamicTable';
import RemoteDropDownSearch from './remotedropDownSearch';
import DynamicTableV2 from './dynamicTableV2';
import Select from './select';
import RemoteCheckboxGroup from './remoteCheckboxGroup';
import Alert from './showAlert';
import TablesReports from './tableReports';

export {
    List,
    DropDownSearch,
    FormBuilder,
    DynamicTable,
    RemoteDropDownSearch,
    DynamicTableV2,
    Select,
    RemoteCheckboxGroup,
    Alert,
    TablesReports
  };



// WEBPACK FOOTER //
// ./components/data-containers/index.js